// extracted by mini-css-extract-plugin
export var card = "_vc-0";